import { CHANGE_USER_ADDRESS_REQUEST, CHANGE_USER_ADDRESS_SUCCESS, CHANGE_USER_ADDRESS_FAILURE } from '../../constants/user_address.constants';

export const changeUserAddressRequest = (user_id, country, city, street, zip_code, state, address_id) => ({
    type: CHANGE_USER_ADDRESS_REQUEST, user_id, country, city, street, zip_code, state, address_id,
});
export const changeUserAddressRequestSuccess = payload => ({ type: CHANGE_USER_ADDRESS_SUCCESS, payload });
export const changeUserAddressRequestFailure = error => ({ type: CHANGE_USER_ADDRESS_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/actions/user_addresses_actions/change_user_address.action.js